import React from 'react';
import PropTypes from 'prop-types';

import OrderSummary from './OrderSummary/OrderSummary';

const OrderSummaries = ({
  labOrder,
  imagingOrder,
  physicianOrder,
  onEditLab,
  onEditImaging,
  onEditPhysician,
  showEdit
}) => {
  return (
    <>
      {labOrder && (
        <OrderSummary
          title="Lab Orders"
          order={labOrder}
          orderKey="labOrder"
          onEdit={onEditLab}
          showEdit={showEdit}
        />
      )}

      {imagingOrder && (
        <OrderSummary
          title="Imaging Orders"
          order={imagingOrder}
          orderKey="imagingOrder"
          onEdit={onEditImaging}
          showEdit={showEdit}
        />
      )}

      {physicianOrder && (
        <OrderSummary
          title="Physician Orders"
          order={physicianOrder}
          orderKey="physicianOrder"
          onEdit={onEditPhysician}
          showEdit={showEdit}
        />
      )}
    </>
  );
};

OrderSummaries.propTypes = {
  labOrder: PropTypes.object,

  imagingOrder:
    PropTypes.object,

  physicianOrder:
    PropTypes.object,

  onEditLab:
    PropTypes.func,

  onEditImaging:
    PropTypes.func,

  onEditPhysician:
    PropTypes.func,

  showEdit:
    PropTypes.bool
};

OrderSummaries.defaultProps = {
  labOrder: null,

  imagingOrder: null,

  physicianOrder: null,

  onEditLab: () => {},

  onEditImaging: () => {},

  onEditPhysician: () => {},

  showEdit: true
};

export default OrderSummaries;